module.exports = __webpack_public_path__ + "static/media/fcfm.cad9ca83.png";